import React from 'react';
import { TokenETH } from '@web3icons/react';

import { routes } from 'containers/Routes';
import { Bitcoin } from 'components/Icons';

import { TRACKER_STEPS } from './constants';

export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  return emailRegex.test(email);
};

export const getStepsWithStatus = (pathname) => {
  const route = routes.find(r => r.pathname === pathname);
  const stepId = route?.step || pathname.replace('/', '');

  let currentGroupIndex = -1;
  TRACKER_STEPS.forEach((step, index) => {
    if (step.subSteps.includes(stepId)) {
      currentGroupIndex = index;
    }
  });

  if (currentGroupIndex === -1) return null;

  return TRACKER_STEPS.map((step, index) => ({
    ...step,
    status:
      index < currentGroupIndex
        ? 'completed'
        : index === currentGroupIndex
          ? 'current'
          : 'upcoming',
  }));
};

export const getCryptoIcon = (crypto, size = 18, className = '') => {
  let Token = null;
  switch (crypto) {
    case 'btc':
      Token = Bitcoin;
      break;
    case 'eth':
      Token = TokenETH;
      break;
    default:
      Token = null;
  }
  return Token ? <Token size={size} className={className} /> : null;
};

export const isDesktopEnvironment = () => {
  if (typeof window === 'undefined') return false;

  return (
    window.matchMedia('(pointer: fine)').matches
    && window.matchMedia('(hover: hover)').matches
    // && window.matchMedia('(min-width: 1024px)').matches
  );
};

export const hideTitleAndFooter = () => {
  const title = document.querySelector('.page-title');
  const footer = document.querySelector('.footer-disclosures');
  const headerImage = document.querySelector('.header-image');
  title.classList.add('hidden');
  footer.classList.add('hidden');
  headerImage.classList.add('hidden');
};

export const showTitleAndFooter = () => {
  const title = document.querySelector('.page-title');
  const footer = document.querySelector('.footer-disclosures');
  const headerImage = document.querySelector('.header-image');
  title.classList.remove('hidden');
  footer.classList.remove('hidden');
  headerImage.classList.remove('hidden');
};
